<app-search></app-search>
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>LISTA ESTADO ECONÓMICO</h1>
        </div>
        <br />
        <!-- <div>
            <button id="" class="primary-button" (click)="create()">
                <span class="button-content">
                    <mat-icon>add_circle</mat-icon>Agregar nuevo
                </span>
            </button>
        </div> -->
        <br />
        <section class="table-container mat-elevation-z1" tabindex="0">
            <table
                mat-table
                [dataSource]="
                    (asyncSocioEconomic | async)?.results ?? []
                        | paginate
                            : {
                                  id: 'server',
                                  itemsPerPage: limit,
                                  currentPage: page,
                                  totalItems: total,
                              }
                "
            >
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef>Acciones</th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        <div class="action-buttons">
                            <a
                                (click)="updateSocioEconomic(socioEconomic)"
                                class="icon-button"
                            >
                                <span class="material-symbols-outlined"
                                    ><mat-icon>edit</mat-icon></span
                                >
                            </a>
                            <a
                                (click)="eliminate(socioEconomic.id)"
                                appOnlysuperuser="/socio-economic"
                                class="icon-button"
                            >
                                <span class="material-symbols-outlined"
                                    ><mat-icon>delete</mat-icon></span
                                >
                            </a>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="personalData">
                    <th mat-header-cell *matHeaderCellDef>Usuario</th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.outsider?.identificationType }}
                        {{ socioEconomic.outsider?.identificationCode }}
                        {{ socioEconomic.outsider?.name }}
                        {{ socioEconomic.outsider?.lastName }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="isHeadOfHousehold">
                    <th mat-header-cell *matHeaderCellDef>Cabeza de hogar</th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.isHeadOfHousehold ? 'Sí' : 'No' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="qtyChildren">
                    <th mat-header-cell *matHeaderCellDef>Cantidad de niños</th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.qtyChildren }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="religion">
                    <th mat-header-cell *matHeaderCellDef>Religión</th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.religion }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="ownsLand">
                    <th mat-header-cell *matHeaderCellDef>Tiene tierra</th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.ownsLand ? 'Sí' : 'No' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="landArea">
                    <th mat-header-cell *matHeaderCellDef>Área del terreno</th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.landArea }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="isConflictVictim">
                    <th mat-header-cell *matHeaderCellDef>
                        Víctima del conflicto
                    </th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.isConflictVictim ? 'Sí' : 'No' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="hasProtectionScheme">
                    <th mat-header-cell *matHeaderCellDef>
                        Esquema de protección
                    </th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.hasProtectionScheme ? 'Sí' : 'No' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="civilianStatus">
                    <th mat-header-cell *matHeaderCellDef>Etado civil</th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.civilianStatus }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="gender">
                    <th mat-header-cell *matHeaderCellDef>Género</th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.gender }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="culturaEthnic">
                    <th mat-header-cell *matHeaderCellDef>Étnia</th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.culturaEthnic }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="sourceIncome">
                    <th mat-header-cell *matHeaderCellDef>
                        Fuente de ingresos
                    </th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.sourceIncome }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="sourceIncomeMethod">
                    <th mat-header-cell *matHeaderCellDef>Forma de ingresos</th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.sourceIncomeMethod }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="disability">
                    <th mat-header-cell *matHeaderCellDef>
                        Tipo de discapacidad
                    </th>
                    <td mat-cell *matCellDef="let socioEconomic">
                        {{ socioEconomic.disability }}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: showColumns"
                    class="highlight-row"
                ></tr>
            </table>
        </section>
        <pagination-controls
            (pageChange)="fetchSocioEconomic($event)"
            previousLabel="Anterior"
            nextLabel="Siguiente"
            id="server"
        ></pagination-controls>
    </div>
</div>
